import { ActionType, createAction, createAsyncAction } from 'typesafe-actions';
import { DefaultErrorPayload, FetchAction, SuccessFetchActionPayload } from '../dataFetching/generators';
import { DataFetchingThunkAction } from '../types';
import { log404ErrorAsWarning } from '../../../common/apiAdapters/ErrorHandlers';
import { PriceFormatConfigOptions } from '../products/types';
import { LooksSliderResponse } from '../looksSlider/types';
import { LooksWithPromo, PartialLookDetail } from './types';

export const fetchLookDetailPageActions = createAsyncAction(
    '@LOOKS_DETAILPAGE/FETCH_START',
    '@LOOKS_DETAILPAGE/FETCH_SUCCESS',
    '@LOOKS_DETAILPAGE/FETCH_FAILED'
)<FetchAction, SuccessFetchActionPayload<LooksWithPromo>, DefaultErrorPayload>();

export const fetchLookDetailPageSliderActions = createAsyncAction(
    '@LOOKS_DETAILPAGE_SLIDER/FETCH_START',
    '@LOOKS_DETAILPAGE_SLIDER/FETCH_SUCCESS',
    '@LOOKS_DETAILPAGE_SLIDER/FETCH_FAILED'
)<FetchAction, SuccessFetchActionPayload<LooksSliderResponse>, DefaultErrorPayload>();

export const setLDPKnownInfoAction = createAction('@LOOKS_DETAILPAGE/SET_INFO', action => {
    return (look: PartialLookDetail) => action({ look });
});

export const FetchLooksDetailPageSliderActions = [
    fetchLookDetailPageSliderActions.failure,
    fetchLookDetailPageSliderActions.request,
    fetchLookDetailPageSliderActions.success,
];

export const fetchLookDetailIfNeeded = (
    urlKey: string,
    reducerPayloadOptions: PriceFormatConfigOptions,
    includePromotions?: boolean
): DataFetchingThunkAction => async (dispatch, getState, { apiService, logger }) => {
    const identifier = urlKey;
    if (identifier === getState().lookDetailPage.identifier) {
        return;
    }
    dispatch(fetchLookDetailPageActions.request({ identifier }));
    try {
        const lookDetail = await apiService.shopApi.getLookDetail(urlKey);
        const promo = await apiService.shopApi.getPromotionsForLooks(urlKey, includePromotions);
        dispatch(
            fetchLookDetailPageActions.success({ data: { lookDetail, promo }, identifier, reducerPayloadOptions })
        );
    } catch (err) {
        log404ErrorAsWarning(err, identifier, logger, 'fetchLookDetailIfNeeded');
        dispatch(fetchLookDetailPageActions.failure({ error: err, identifier }));
    }
};

export type LookDetailPageActionType =
    | ActionType<typeof fetchLookDetailPageActions>
    | ActionType<typeof setLDPKnownInfoAction>;
export type LooksDetailPageSliderActionsType = ActionType<typeof fetchLookDetailPageSliderActions>;
